import React, { Component } from 'react';
import { RetrieveRequest, DetailRequest } from '../../../utilities/services/RequestService';
import { api } from '../../../config/Services';
import { connect } from "react-redux";
import { Alert } from '../../../components';
import { Form, Row, Col, Spin, Tabs, Typography, Divider, Tag, Skeleton, Layout, Modal, Icon } from 'antd';
import TopUp from './topup/Index';
import Report from './report/Index';
import Transaction from './transaction/Index';
import { getProfile } from '../../../utilities/services/AuthService';
import { Link } from 'react-router-dom';
import { formatNumber } from '../../../utilities/actions/Helpers';
import Cobrand from './Cobrand'
import moment from 'moment';

const { TabPane } = Tabs;
const { Title } = Typography;

const tagStatus = {
    ACTIVE: { value: 'ACTIVE', label: 'ACTIVE', color: '#13d416' },
    INACTIVE: { value: 'INACTIVE', label: 'INACTIVE', color: '#f1f514' },
    INACTIVEEMAIL: { value: 'INACTIVEEMAIL', label: 'INACTIVE EMAIL', color: '#c91010' },
    GRACEPERIOD: { value: 'GRACEPERIOD', label: 'GRACE PERIOD', color: '#c97010' },
    MERGED: { value: 'MERGED', label: 'MERGED', color: '#c91010' },
    DECEASED: { value: 'DECEASED', label: 'DECEASED', color: '#c91010' },
    TEST: { value: 'TEST', label: 'TEST', color: '#135ad4' },
    SUSPECTEDFRAUD: { value: 'SUSPECTEDFRAUD', label: 'SUSPECTED FRAUD', color: '#c91010' },
    FRAUD: { value: 'FRAUD', label: 'FRAUD', color: '#c91010' },
    TERMINATED: { value: 'TERMINATED', label: 'TERMINATED', color: '#c91010' },
    SUSPECTDUPLICATE: { value: 'SUSPECTDUPLICATE', label: 'SUSPECT DUPLICATE', color: '#0de0ba' },
    DUPLICATE: { value: 'DUPLICATE', label: 'DUPLICATE', color: '#0de0ba' }
}

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            isLoading: true,
            validationrulesvalue: [],
            maxlengthvalue: null,
            fielddisabled: {
                generalfielddisabled: false,
                specialfielddisabled: false
            },
            visible: false,
            havebulk: false,
            partnercode: null
        }
    }

    componentDidMount() {
        this.getDetail();
    }

    getDetail = () => {
        let profile = getProfile();
        let username = profile.username;
        let url = api.url.user.user.list;
        let paging = {};
        let criteria = { username };
        let sort = {};
        //call loader
        this.setState({ loading: true });
        RetrieveRequest(url, criteria, sort, paging).then((response) => {
            const { status, result } = response;
            if (status.responsecode === '0000' && result) {
                if (result.length !== 0) {
                    let partnercode = (result[0].partnercode) ? result[0].partnercode : '';
                    this.setState({ partnercode, loading: false });
                    this.headerDetail();
                } else {
                    this.setState({ responseMessage: 'Data not found', formrender: false });
                }
            } else {
                this.setState({
                    responseCode: status.responsecode,
                    responseMessage: status.responsemessage,
                    formrender: false,
                });
            }
        });
    }

    headerDetail = () => {
        let url = api.url.dashboard.detail;
        let data = { partnercode: this.state.partnercode };
        //call loader
        this.setState({ isLoading: true });
        DetailRequest(url, data).then((response) => {
            const { status, result } = response;
            const { responsecode, responsemessage } = response.status;
            if (responsecode === '0000' && result) {
                let dataList = result;
                let remainingbalance = (result.remainingbalance) ? result.remainingbalance : '';
                let havebulk = (result.havebulk) ? result.havebulk : false;
                if ((remainingbalance < 30000) && havebulk) this.warningMiles();

                this.setState({ dataList, havebulk, isLoading: false });
            } else {
                Alert.error(responsemessage);
                this.setState({
                    responseCode: status.responsecode,
                    responseMessage: status.responsemessage,
                    formrender: false
                });
            }
        });
    }

    handleOpenModal = () => {
        this.setState({ visible: true });
    };

    handleCancel = () => {
        this.setState({ visible: false });
    };

    warningMiles = () => {
        Modal.warning({
            title: 'Warning',
            content: 'Remaining Miles is less than 30.000',
        });
    }

    render() {
        const { partnercode, loading, isLoading, dataList, visible, havebulk } = this.state;
        const { remainingbalance, partnerlogo, partnername, totalmembercobrand, usagebalance, startdate, enddate } = dataList || {};
        //render form
        return (
            <Row>
                {isLoading ?
                    <Layout className='header-layout'>
                        <Skeleton active />
                    </Layout>
                    :
                    <Row gutter={24} >
                        <Col xs={24} sm={24} md={4} style={{ textAlign: 'center' }}>
                            <div className="member-card">
                                <img src={partnerlogo} alt="" width="130" height="100" />
                            </div>
                        </Col>
                        <Col xs={24} sm={24} md={4}>
                            <Row gutter={24}>
                                <Col xs={24}>
                                    <Row>
                                        <Col span={24} style={{ textAlign: 'center', textTransform: 'uppercase', fontSize: '16px', color: '#1a1a1a', fontWeight: '700' }}>
                                            {partnername}<br />
                                            <Tag color={tagStatus['ACTIVE']['color']} style={{ marginRight: 0, color: 'white' }}>{tagStatus['ACTIVE']['label']}</Tag>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                        <Col xs={24} sm={24} md={16}>
                            <Row >
                                <Col xs={24} sm={24} md={4} lg={8} style={{ textAlign: 'center', borderRight: '1px solid #e9e9e9', borderLeft: '1px solid #e9e9e9' }}>
                                    <Row className="member-profile">
                                        <Col xs={24} sm={24} md={8} lg={24} style={{ textAlign: 'center', textTransform: 'uppercase', }}>
                                            <p>REMAINING BALANCE BULK MILES</p>
                                            <span style={{ fontSize: '23px', color: remainingbalance < 30000 ? 'red' : '' }}> {formatNumber((remainingbalance ?? 0).toString())}</span>
                                            <Icon className={(remainingbalance < 30000) && havebulk ? '' : 'hidden'} type="warning" theme="twoTone" twoToneColor="#ffec3d" style={{ marginLeft: 5, fontSize: '20px' }} onClick={() => this.warningMiles()} />
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xs={24} sm={24} md={4} lg={8} style={{ textAlign: 'center', borderRight: '1px solid #e9e9e9' }}>
                                    <Row className="member-profile">
                                        <Col xs={24} sm={24} md={8} lg={24} style={{ textAlign: 'center', textTransform: 'uppercase', }}>
                                            <p>REGULAR MILES</p>
                                            <span style={{ fontSize: '23px' }}> {formatNumber((usagebalance ?? 0).toString())}</span>
                                        </Col>
                                    </Row>
                                </Col>
                                {/* <Col xs={24} sm={24} md={4} lg={6} style={{ textAlign: 'center', borderRight: '1px solid #e9e9e9' }}>
                                    <Row className="member-profile">
                                        <Col xs={24} sm={24} md={8} lg={24} style={{ textAlign: 'center', textTransform: 'uppercase', }}>
                                            <p>COBRAND MEMBER</p>
                                            <span style={{ fontSize: '23px' }}> {formatNumber((totalmembercobrand ?? 0).toString())}</span>
                                        </Col>
                                        <Col xs={24} sm={24} md={24} lg={24} xl={24} style={{ textAlign: 'center' }}>
                                            <Link to="#" onClick={this.handleOpenModal} style={{ cursor: 'pointer' }}>View Detail</Link>
                                        </Col>
                                    </Row>
                                </Col> */}
                                <Col xs={24} sm={24} md={8} style={{ textAlign: 'center' }}>
                                    <Row className="member-profile">
                                        <Col xs={24} sm={24} md={8} lg={24} style={{ textAlign: 'center', }}>
                                            <p>VALIDATE</p>
                                        </Col>
                                        <Col xs={24} sm={24} md={8} lg={12} style={{ textAlign: 'center' }}>
                                            <p>START DATE</p>
                                            <span style={{ fontSize: '12px' }}> {moment(startdate).format('DD/MM/YYYY')}</span>
                                        </Col>
                                        <Col xs={24} sm={24} md={8} lg={12} style={{ textAlign: 'center', }}>
                                            <p>END DATE</p>
                                            <span style={{ fontSize: '12px' }}> {moment(enddate).format('DD/MM/YYYY')}</span>
                                        </Col>
                                    </Row >
                                </Col >
                            </Row>
                        </Col>
                    </Row>
                }
                <Divider />
                <Spin spinning={this.state.loading}>
                    {havebulk ?
                        <Tabs tabPosition="left" destroyInactiveTabPane={true}>
                            {
                                <TabPane tab="Top up Bulk Miles" key="1">
                                    <TopUp {...this.props} partnercode={partnercode} />
                                </TabPane>

                            }
                            {
                                <TabPane tab="Transaction" key="2">
                                    <Transaction {...this.props} partnercode={partnercode} />
                                </TabPane>
                            }
                            {
                                <TabPane tab="Partner Report" key="3">
                                    <Report {...this.props} partnercode={partnercode} />
                                </TabPane>
                            }
                        </Tabs>
                        : partnercode ?
                            <Tabs tabPosition="left" destroyInactiveTabPane={true}>
                                {
                                    <TabPane tab="Transaction" key="1">
                                        <Transaction {...this.props} partnercode={partnercode} />
                                    </TabPane>
                                }
                                {
                                    <TabPane tab="Partner Report" key="2">
                                        <Report {...this.props} partnercode={partnercode} />
                                    </TabPane>
                                }
                            </Tabs>
                            : ''}
                </Spin>
                <Modal visible={visible} title={'Cobrand Member'} onCancel={this.handleCancel} footer={null} destroyOnClose={true} width={500}>
                    <Cobrand partnercode={partnercode} closemodalrefresh={this.handleCancel} />
                </Modal>
            </Row>
        )
    }
}

const mapStateToProps = state => ({ ...state });
export default connect(mapStateToProps)(Form.create()(App));